import { Countries, SKIP_ENGLISH_LEVEL_FOR_COUNTRIES_LIST } from '../constants';

export const isSkipEnglishLevelBasedOnCountry = (
  country: string | null | undefined,
): boolean => {
  return SKIP_ENGLISH_LEVEL_FOR_COUNTRIES_LIST.includes(
    (country as Countries) ?? '',
  );
};
